import React from 'react';

/*
import {
  hf,
  ht,
  cr,
  a,
  ls,
  f,
  useMsgz,
  BoxC,
  BtnCttC,
  IptC,
  LblC,
  GridC,
  TextC,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as IptC from "./_ccbIptC";
import * as TextC from "./_ccbTextC";
import * as GridC from "./_cccGridC";
import * as LblC from "./_cccLblC";
import * as BtnCttC from "./_ccmBtnCttC";
import * as cmFTH from "./_cmFTH"; // 廃止予定
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as ls from "./_csLcl"; // local state
import { useMsgz } from "./_csMdlMsg";
import * as ht from './_ht';
import * as hf from './_hf';

import * as ihd from 'src/ihd';
import * as ica from 'src/ica';

import * as icvi17 from './icvI17___Mz';

let $i17z = icvi17.itlI17z();

export const B = (pz: ht.btnCttCz) => {
  const _sMsgz = useMsgz();
  return (
    cr.c(BtnCttC.N, {
      key: -10,
      ... pz,
      cz: {
        ... pz.cz,
        ugdAsync: async () => {
          const _i17rz = $i17z.i17rz;
          const _b = await hf.ectSrlAsync([
            async () => { // 必須項目の確認
              let _b = true;
              if (
                !hf.f(_i17rz._icn) || // 部屋ID
                !hf.f(_i17rz._pfx) // 部屋名
              ) _b = false;
              if (!_b) {
                _sMsgz.show({
                  textCz: {
                    textz: {
                      pfx: '必須項目が入力されていないため、指定された操作を行うことができません',
                    }
                  }
                })
              }
              return _b;
            },
          ])
          if (_b) {
            const _i17z = await icvi17.saveI17rDzAsync({
              ... pz,
              i17z: $i17z,
            }) as ht.dz;
            return {
              i17r_fst: _i17z.i17rz._fst,
            };
          }
        },
        dltAsync: async () => {
          await icvi17.saveI17rDzAsync({
            ... pz,
            i17z: { 
              i17rz: {
                ... $i17z.i17rz,
                _dlt: 1,
              }
            }
          }) as ht.dz;
        },
      }
    })
  );
};

export const D = (pz: ht.viewDtlCz) => {

  const _frcUdt = ls.frcUdt();

  React.useEffect( () => {
    cmFTH.loadAllAsync({
      phs: pz.sPz.crt.phs,
      frcUdt: _frcUdt,
      crtAsync: () => [
        icvi17.crtI17z()
        .then((_dz: ht.dz) => {
          $i17z = _dz;
        })
      ],
      udtAsync: () => [
        icvi17.loadI17rDzAsync({
          i17r_fst: pz.sPz.crt.i17r_fst,
          vsn: pz.sPz.crt.vsn,
        })
        .then((_dz: ht.dz) => {
          $i17z = _dz;
        })
      ]
    });
  }, [
    pz.sPz.crt.phs,
    pz.sPz.crt.i17r_fst,
    pz.sPz.crt.vsn,
  ])

  const _abtType = pz.abtType ?? 'nmlz';
  const _abtz = ica.viewDtlAbtz[_abtType] ? ica.viewDtlAbtz[_abtType]() : {};

  return (
    cr.c(BoxC.N, {
      key: -10,
      boxStlz: a('dw/f fd/csc'),
      oClds: [

        hf.i(pz.sPz.crt.phs, [`crt`, `udt`]) ?
        cr.c(TextC.N, {
          key: -5,
          abtType: 'rmkCmnz',
          boxStlz: a(`dw/f fd/rsc mb/1`),
          textz: {
            pfx: '※：必須'
          }
        })
        : null,

        cr.c(GridC.N, {
          key: -10,
          abtType: 'nolineCmnz',
          boxStlz: a('dwx/60 mb/2 mh/a'),
          lineCs: [
            {
              boxStlz: a(`mb/1`),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        boxStlz: a(`dw/18`),
                        textz: {
                          pfx: '備品・駐車場ID：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: $i17z?.i17rz._icn ?? '',
                              onChg: ( _s: ht.s ) => {
                                $i17z.i17rz._icn = _s;
                              },
                            }
                          })
                        ],
                      },
                      omtCz: 
                        hf.i(pz.sPz.crt.phs, [`crt`, `udt`]) ?
                        {
                          abtType: 'omtRqrCmnz',
                        }
                        : undefined,
                    }),
                  ]
                },
              ]
            },
            {
              boxStlz: a(`mb/1`),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        boxStlz: a(`dw/18`),
                        textz: {
                          pfx: '備品・駐車場名：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: $i17z?.i17rz._pfx,
                              onChg: ( _s: ht.s ) => {
                                $i17z.i17rz._pfx = _s;
                              },
                            }
                          })
                        ],
                      },
                      omtCz: 
                        hf.i(pz.sPz.crt.phs, [`crt`, `udt`]) ?
                        {
                          abtType: 'omtRqrCmnz',
                        }
                        : undefined,
                    }),
                  ]
                },
              ]
            },
            {
              boxStlz: a(`mb/1`),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        boxStlz: a(`dw/18`),
                        textz: {
                          pfx: '使用可能数：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: $i17z?.i17rz.i17ra1100i ?? 1,
                              onChg: ( _s: ht.s ) => {
                                $i17z.i17rz.i17ra1100i = _s;
                              },
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
              ]
            },
            {
              boxStlz: a(`mb/1`),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        boxStlz: a(`dw/18`),
                        textz: {
                          pfx: '利用料：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: $i17z?.i17rz.i17rm1100i ?? '0',
                              onChg: ( _s: ht.s ) => {
                                $i17z.i17rz.i17rm1100i = _s;
                              },
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
              ]
            },
            {
              boxStlz: a(`mb/1`),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        boxStlz: a(`dw/18`),
                        textz: {
                          pfx: '利用料の単位：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'pcr',
                              ls: ihd.f('i17rt1100i').ls,
                              vle: $i17z?.i17rz.i17rt1100i,
                              onChg: ( _dz: ht.dz ) => {
                                $i17z.i17rz.i17rt1100i = _dz.key;
                              },
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
              ]
            },
          ]
        }),

      ]
    })
  );
};

